<template>
    <ScrollTop
        :threshold="100"
        icon="pi pi-arrow-up"
    />
</template>

<script>
import ScrollTop from 'primevue/scrolltop';

export default {
    components: {
        ScrollTop
    }
}
</script>

<style>

</style>